const customFlowRoutesMeta = {
  routeName: window.$_t("CUSTOM FLOW"),
  noPadding: true,
  skipGlobalLoader: true,
  requiredRoles: [],
};

export const customFlowsRoutes = [
  {
    path: "/app/custom-flows",
    component: () => import("vue-app/pages/PageCustomFlows.vue"),
    redirect: "/app/custom-flows/cf-dashboard",
    children: [
      {
        path: "/app/custom-flows/cf-dashboard",
        component: () => import("vue-app/pages/PageCustomFlowsDashboard.vue"),
        meta: customFlowRoutesMeta,
      },
      {
        path: "/app/custom-flows/cf-dashboard/new",
        component: () => import("vue-app/pages/PageCustomFlowsCreate.vue"),
        meta: customFlowRoutesMeta,
      },
      {
        path: "/app/custom-flow/:id",
        component: () => import("vue-app/pages/PageCustomFlowsEdit/PageCustomFlowsEdit.vue"),
        meta: {
          ...customFlowRoutesMeta,
          skipGlobalLoader: false,
        },
      },
      {
        path: "/app/custom-flow/local-rejected/:customFlowId/:customFlowElementId",
        component: () => import("vue-app/pages/PageCustomFlowLocalRejected.vue"),
        meta: customFlowRoutesMeta,
      },
      {
        path: "/app/custom-flows/design-emails",
        component: () => import("vue-app/pages/PageCustomFlowsDesignEmails.vue"),
        meta: customFlowRoutesMeta,
      },
      {
        path: "/app/custom-flows/design-popups",
        component: () => import("vue-app/pages/PageCustomFlowsDesignPopups.vue"),
        meta: customFlowRoutesMeta,
      },
      {
        path: "/app/custom-flows/design-sms",
        component: () => import("vue-app/pages/PageCustomFlowsDesignSms.vue"),
        meta: customFlowRoutesMeta,
      },
      {
        path: "/app/custom-flows/design-popup/:id",
        component: () => import("vue-app/pages/PageCustomFlowsDesignPopup.vue"),
        meta: {
          ...customFlowRoutesMeta,
          skipGlobalLoader: false,
        },
      },
      {
        path: "/app/custom-flows/design-whatsapp",
        name: "PageCustomFlowsDesignWhatsApps",
        component: () => import("vue-app/pages/PageCustomFlowsDesignWhatsApps.vue"),
        meta: customFlowRoutesMeta,
      },
      {
        path: "/app/custom-flows/design-whatsapp/:id",
        name: "PageCustomFlowsDesignWhatsApp",
        component: () => import("vue-app/pages/PageCustomFlowsDesignWhatsApp/PageCustomFlowsDesignWhatsApp.vue"),
        meta: customFlowRoutesMeta,
      },
    ],
  },
  {
    path: "/app/custom-flows/coupons",
    component: () => import("vue-app/pages/PageCoupons/PageCoupons.vue"),
    meta: {
      routeName: window.$_t("CUSTOM FLOWS"),
      noPadding: true,
      skipGlobalLoader: true,
    },
  },
];
